"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function get() {
    return _parser.parse;
  }
});
Object.defineProperty(exports, "SyntaxError", {
  enumerable: true,
  get: function get() {
    return _parser.SyntaxError;
  }
});
exports.parseSubstitution = exports.parseValuation = exports.parseTuples = exports.parseDomain = exports.parseFunctions = exports.parsePredicates = exports.parseConstants = exports.parseIClause = exports.parseITerm = exports.parseClause = exports.parseFormulaWithPrecedence = exports.parseFormulaStrict = exports.parseTerm = void 0;

var _parser = require("./parser");

var _startRules = _interopRequireDefault(require("./parser/startRules"));

var parseTerm = function parseTerm(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Term,
    language: language,
    factories: factories
  });
};

exports.parseTerm = parseTerm;

var parseFormulaStrict = function parseFormulaStrict(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.FormulaStrict,
    language: language,
    factories: factories
  });
};

exports.parseFormulaStrict = parseFormulaStrict;

var parseFormulaWithPrecedence = function parseFormulaWithPrecedence(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.FormulaWithPrecedence,
    language: language,
    factories: factories
  });
};

exports.parseFormulaWithPrecedence = parseFormulaWithPrecedence;

var parseClause = function parseClause(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Clause,
    language: language,
    factories: factories
  });
};

exports.parseClause = parseClause;

var parseITerm = function parseITerm(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.ITerm,
    language: language,
    factories: factories
  });
};

exports.parseITerm = parseITerm;

var parseIClause = function parseIClause(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.IClause,
    language: language,
    factories: factories
  });
};

exports.parseIClause = parseIClause;

var parseConstants = function parseConstants(input) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Constants,
    language: null,
    factories: null
  });
};

exports.parseConstants = parseConstants;

var parsePredicates = function parsePredicates(input) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Predicates,
    language: null,
    factories: null
  });
};

exports.parsePredicates = parsePredicates;

var parseFunctions = function parseFunctions(input) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Functions,
    language: null,
    factories: null
  });
};

exports.parseFunctions = parseFunctions;

var parseDomain = function parseDomain(input) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Domain,
    language: null,
    factories: null
  });
};

exports.parseDomain = parseDomain;

var parseTuples = function parseTuples(input) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Tuples,
    language: null,
    factories: null
  });
};

exports.parseTuples = parseTuples;

var parseValuation = function parseValuation(input, language) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Valuation,
    language: language,
    factories: null
  });
};

exports.parseValuation = parseValuation;

var parseSubstitution = function parseSubstitution(input, language, factories) {
  return (0, _parser.parse)(input, {
    startRule: _startRules.default.Substitution,
    language: language,
    factories: factories
  });
};

exports.parseSubstitution = parseSubstitution;